// App.js
import React, { useContext } from 'react';
import { Route, Routes, Navigate, useLocation, useParams } from 'react-router-dom';
import BuyerLayout from "./Layouts/BuyerLayout";
import 'react-toastify/dist/ReactToastify.css';
import { ToastContainer } from 'react-toastify';
import Home from "./Pages/buyer/Home";
import SignInPage from './Pages/buyer/SignInPage';
import SignUpPage from './Pages/buyer/SignUpPage';
import CompleteSignUp from './Pages/buyer/CompleteSignUp';
import { LoginContext } from './Contexts/LoginContext';
import ScrollToTop from './Components/utils/ScrollToTop';
import Products from './Pages/buyer/Products';
import Categories from './Pages/buyer/Categories';
import ProductDetail from './Pages/buyer/ProductDetail';
import VendorDetail from './Pages/buyer/VendorDetail';
import BlogPage from './Pages/buyer/Blogs';
import TradeLeadsPage from './Pages/buyer/TradeLeadPage';
import TradeLeadForm from './Pages/buyer/TradeLeadForm';
import OrdersPage from './Pages/buyer/OrdersPage'
import SettingsPage from './Pages/buyer/SettingsPage'
import BookmarkSellers from './Pages/buyer/BookmarkSellers';
import ChatPage from './Pages/buyer/ChatPage';
import MyReviews from './Pages/buyer/MyReviewsPage';
import OrderTrackingPage from './Pages/buyer/OrderTrackingPage';
import AccountCreditsPage from './Pages/buyer/AccountCreditsPage';
// import ProfilePage from './Pages/buyer/ProfilePage';
import BecomeSeller from './Pages/seller/BecomeSeller';
import ArticleDetailPage from './Pages/buyer/ArticleDetailPage';
import SellerDashboard from './Pages/seller/SellerDashboard';
import CreateProductPage from './Pages/seller/CreateProductPage';
// import PackagesPage from './Pages/seller/PackagesPage';
import SellerTradeLead from './Pages/seller/SellerTradeLead';
import AnalyticsPage from './Pages/seller/AnalyticsPage';

import ResetPasswordRequest from "./Pages/buyer/ResetPasswordRequest"
import ResetPassword from "./Pages/buyer/ResetPassword"

import { CheckoutStripeContainer, OrderDetailsStripeContainer, UpgradeStripeContainer, PostingsStripeContainer } from './config/StripeContainer';
import AdminLogin from './Pages/admin/AdminLogin';
import AdminProtectedRoute from './config/AdminProtectedRoute';
import AdminDashboard from "./Pages/admin/AdminDashboard"
import AdminOrders from './Pages/admin/AdminOrders';
import AdminSellers from './Pages/admin/AdminSellers';
import AdminBuyers from './Pages/admin/AdminBuyers';
import AdminProducts from './Pages/admin/AdminProducts';
import AdminSocialLinks from './Pages/admin/AdminSocialLinks';
import AdminTerms from './Pages/admin/AdminTerms';
import AdminEmployees from './Pages/admin/AdminEmployees';
import AdminCategories from './Pages/admin/AdminCategories';
import AdminFee from './Pages/admin/AdminFee';
import AdminPayments from './Pages/admin/AdminPayments';
import AdminRevenue from './Pages/admin/AdminRevenue';
import AdminAnalytics from './Pages/admin/AdminAnalytics';
import Terms from './Pages/buyer/Terms';
import FAQPage from './Pages/buyer/FAQPage';
import LoginProtectedRoute from "./config/LoginProtectedRoute"
import SellerProtectedRoute from "./config/SellerProtectedRoute"
import ContactUs from './Pages/buyer/ContactUs';
import MobileRestricted from './Components/utils/MobileRestricted';
import AdminBlog from './Pages/admin/AdminBlog';
import AdminRestrictions from './Pages/admin/AdminRestrictions';
import AdminFAQ from './Pages/admin/AdminFAQ';
import AdminEmails from './Pages/admin/AdminEmails';
import AdminBanners from './Pages/admin/AdminBanners';
import AdminDisputes from './Pages/admin/AdminDisputes';
import AdminManageDispute from './Pages/admin/AdminManageDispute';
import NotFound from './Pages/buyer/NotFound';
import EmailVerified from './Pages/buyer/EmailVerified';

import B2BHome from './Pages/buyer/B2BHome';
import B2BProducts from './Pages/buyer/B2BProducts';
import B2BCategories from './Pages/buyer/B2BCategories';

import './Styles/b2b.css';

function RedirectB2BListingToProductDetail() {
    const { id } = useParams();
    return <Navigate to={`/productDetail/${id}?market=b2b`} replace />;
}

function RedirectLegacyB2BProductDetail() {
    const { id } = useParams();
    return <Navigate to={`/productDetail/${id}?market=b2b`} replace />;
}

function RedirectB2BListingsToProducts() {
    const location = useLocation();
    const params = new URLSearchParams(location.search || '');
    params.delete('market');
    return <Navigate to={`/b2b/products-services${params.toString() ? `?${params.toString()}` : ''}`} replace />;
}

function ProductsRoute() {
    const location = useLocation();
    const params = new URLSearchParams(location.search || '');
    if (params.get('market') === 'b2b') {
        params.delete('market');
        return <Navigate to={`/b2b/products-services${params.toString() ? `?${params.toString()}` : ''}`} replace />;
    }
    return <Products />;
}

function RedirectB2BSellerDashboard() {
    return <Navigate to="/sellerDashboard" replace />;
}

function RedirectB2BSellerListings() {
    return <Navigate to="/postings" replace />;
}

function RedirectB2BSellerCreateListing() {
    return <Navigate to="/createProduct/new?market=b2b" replace />;
}

function RedirectB2BSellerEditListing() {
    const { id } = useParams();
    return <Navigate to={`/createProduct/${id}?market=b2b`} replace />;
}

function RedirectB2BSellerApply() {
    return <Navigate to="/becomeSeller?mode=b2b-upgrade" replace />;
}

function App() {

    const { isTabletPro } = useContext(LoginContext);

    return (

        <>
            < ScrollToTop />

            <Routes>

                <Route element={<BuyerLayout />}>
                    <Route path='/' element={<Home />} />
                    <Route path='/categories' element={<Categories />} />
                    <Route path='/products-services' element={<ProductsRoute />} />
                    <Route path='/productDetail/b2b/:id' element={<RedirectLegacyB2BProductDetail />} />
                    <Route path='/productDetail/:id' element={<ProductDetail />} />
                    <Route path='/vendorDetail/:sellerId' element={<VendorDetail />} />
                    <Route path='/blogs' element={<BlogPage />} />
                    <Route path='/articleDetail/:slug' element={<ArticleDetailPage />} />
                    {/* <Route path='/profilePage' element={<ProfilePage />} /> */}
                    <Route path='/terms' element={<Terms />} />
                    <Route path='/faq' element={<FAQPage />} />
                    <Route path='/contact' element={<ContactUs />} />
                </Route>

                {/* B2B Public Routes */}
                <Route element={<BuyerLayout />}>
                    <Route path='/b2b' element={<B2BHome />} />
                    <Route path='/b2b/categories' element={<B2BCategories />} />
                    <Route path='/b2b/products-services' element={<B2BProducts />} />
                    <Route path='/b2b/listings' element={<RedirectB2BListingsToProducts />} />
                    <Route path='/b2b/listing/:id' element={<RedirectB2BListingToProductDetail />} />
                </Route>

                {/* B2B Buyer Routes (login required) */}

                {/* B2B Seller Routes */}
                <Route element={<LoginProtectedRoute />}>
                    <Route path='/b2b/seller/apply' element={<RedirectB2BSellerApply />} />
                    <Route path='/b2b/seller/dashboard' element={<RedirectB2BSellerDashboard />} />
                    <Route path='/b2b/seller/listings' element={<RedirectB2BSellerListings />} />
                    <Route path='/b2b/seller/listings/create' element={<RedirectB2BSellerCreateListing />} />
                    <Route path='/b2b/seller/listings/edit/:id' element={<RedirectB2BSellerEditListing />} />
                </Route>

                <Route element={<LoginProtectedRoute />}>
                    <Route path='/postRequirements' element={<TradeLeadsPage />} />
                    <Route path='/tradeLeadForm' element={<TradeLeadForm />} />
                    <Route path='/orders' element={<OrdersPage />} />
                    <Route path='/orderDetailPage/:orderId' element={<OrderDetailsStripeContainer />} />
                    <Route path='/orderTrackingPage/:orderId' element={<OrderTrackingPage />} />
                    <Route path='/checkoutPage' element={<CheckoutStripeContainer />} />
                    <Route path='/settings' element={<SettingsPage />} />
                    <Route path='/bookmarkSellers' element={<BookmarkSellers />} />
                    <Route path='/myReviews' element={<MyReviews />} />
                    <Route path='/account/credits' element={<AccountCreditsPage />} />
                </Route>
                <Route element={<LoginProtectedRoute isFooter={false} />}>
                    <Route path='/chats' element={isTabletPro ? (<MobileRestricted />) : (<ChatPage />)} />
                </Route>

                <Route element={<SellerProtectedRoute />}>
                    <Route path='/sellerDashboard' element={<SellerDashboard />} />
                    <Route path='/postings' element={<PostingsStripeContainer />} />
                    <Route path='/seller/productDetail/:id' element={<ProductDetail />} />
                    <Route path="/createProduct/:id" element={<CreateProductPage />} />
                    {/* <Route path='/packages' element={<PackagesPage />} /> */}
                    <Route path='/seller/orders' element={<OrdersPage isSeller={true} />} />
                    <Route path='/sellerOrderDetailPage/:orderId' element={<OrderDetailsStripeContainer />} />
                    <Route path='/sellerOrderTrackingPage/:orderId' element={<OrderTrackingPage />} />
                    <Route path='/earnings' element={<AnalyticsPage />} />
                    <Route path='/upgrade' element={<UpgradeStripeContainer />} />
                    <Route path='/seller/myReviews' element={<MyReviews />} />
                    <Route path='/seller/settings' element={<SettingsPage />} />
                    <Route path='/seller/contact' element={<ContactUs />} />
                </Route>

                <Route element={<SellerProtectedRoute isDestinationTradelead={true} />}>
                    <Route path='/tradeLead' element={<SellerTradeLead />} />
                </Route>

                <Route element={<SellerProtectedRoute isFooter={false} />}>
                    <Route path='/seller/chats' element={<ChatPage />} />
                </Route>

                <Route>
                    <Route path='/signin' element={<SignInPage />} />
                    <Route path='/signup' element={<SignUpPage />} />
                    <Route path='/completeProfile' element={<CompleteSignUp />} />
                    <Route path='/becomeSeller' element={<BecomeSeller />} />
                    <Route path='/resetPasswordRequest' element={<ResetPasswordRequest />} />
                    <Route path='/resetPassword/:token' element={<ResetPassword />} />
                    <Route path='/chwi-admin/login' element={isTabletPro ? (<MobileRestricted />) : (<AdminLogin />)} />
                </Route>

                <Route element={<AdminProtectedRoute />}>
                    <Route path="/chwi-admin/dashboard" element={<AdminDashboard />} />
                    <Route path='/chwi-admin/orders' element={<AdminOrders />} />
                    <Route path="/chwi-admin/sellers" element={<AdminSellers />} />
                    <Route path="/chwi-admin/buyers" element={<AdminBuyers />} />
                    <Route path='/chwi-admin/products-services' element={<AdminProducts />} />
                    <Route path="/chwi-admin/social" element={<AdminSocialLinks />} />
                    <Route path="/chwi-admin/terms" element={<AdminTerms />} />
                    <Route path="/chwi-admin/employees" element={<AdminEmployees />} />
                    <Route path="/chwi-admin/fee" element={<AdminFee />} />
                    <Route path="/chwi-admin/categories" element={<AdminCategories />} />
                    <Route path='/chwi-admin/payments' element={<AdminPayments />} />
                    <Route path='/chwi-admin/revenue' element={<AdminRevenue />} />
                    <Route path='/chwi-admin/analytics' element={<AdminAnalytics />} />
                    <Route path='/chwi-admin/restrictions' element={<AdminRestrictions />} />
                    <Route path='/chwi-admin/chats' element={<ChatPage />} />
                    <Route path='/chwi-admin/blogs' element={<AdminBlog />} />
                    <Route path='/chwi-admin/banners' element={<AdminBanners />} />
                    <Route path='/chwi-admin/faq' element={<AdminFAQ />} />
                    <Route path='/chwi-admin/emails' element={<AdminEmails />} />
                    <Route path='/chwi-admin/disputes' element={<AdminDisputes />} />
                    <Route path='/chwi-admin/disputes/:id' element={<AdminManageDispute />} />
                </Route>

                <Route path='/email-verified' element={<EmailVerified />} />
                <Route path='*' element={<NotFound />} />

            </Routes>

            <ToastContainer position="bottom-left" />
        </>

    );
}

export default App;